export default "__VITE_ASSET__B4ugxAJ4__"